import { Tabs } from '@gate/gui'
import { useTranslation } from 'next-i18next'
import { EnumCoinHeatTimeTab } from '@/constants/index'
import { PriceChartTimeTabStyled } from 'blocks/Price/PriceChart/style'

/**
 * @description: 热力图tabs
 * @return {*}
 */

export type PriceHotValueType = string & EnumCoinHeatTimeTab[keyof EnumCoinHeatTimeTab]

interface PriceHotTabProps {
  priceHeatChartTimeTab: PriceHotValueType
  handlePriceHotTabChange: (val: PriceHotValueType) => void
  isShow: boolean
}

const PriceHotTab: React.FC<PriceHotTabProps> = ({ priceHeatChartTimeTab, handlePriceHotTabChange, isShow }) => {
  const { t } = useTranslation()

  return (
    <PriceChartTimeTabStyled isShow={isShow}>
      <Tabs
        size="xs"
        type="fourth-capsule-grey"
        value={priceHeatChartTimeTab}
        onTabChange={(tab: PriceHotValueType) => {
          handlePriceHotTabChange(tab)
        }}
      >
        <Tabs.List style={{ flexWrap: 'nowrap' }}>
          <Tabs.Tab value={EnumCoinHeatTimeTab.ONE_DAY} aria-selected={false}>
            <span>{t(`P.1D`)}</span>
          </Tabs.Tab>
          <Tabs.Tab value={EnumCoinHeatTimeTab.SEVEN_DAY} aria-selected={false}>
            <span>{t(`P.7D`)}</span>
          </Tabs.Tab>
          <Tabs.Tab value={EnumCoinHeatTimeTab.ONE_MONTH} aria-selected={false}>
            <span>{t(`P.1M`)}</span>
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
    </PriceChartTimeTabStyled>
  )
}

export default PriceHotTab
